<template>
    <div class="row">
      <div class="col-md-6 mb-4">
        <div class="card shadow-sm border-start border-primary border-5">
          <div class="card-body d-flex align-items-center">
            <div class="me-3">
              <i class="fas fa-users fa-2x text-primary"></i>
            </div>
            <div>
              <h6 class="text-muted mb-1">Utilisateurs</h6>
              <h4 class="mb-0">{{ stats.utilisateurs }}</h4>
            </div>
          </div>
        </div>
      </div>
  
      <div class="col-md-6 mb-4">
        <div class="card shadow-sm border-start border-success border-5">
          <div class="card-body d-flex align-items-center">
            <div class="me-3">
              <i class="fas fa-briefcase fa-2x text-success"></i>
            </div>
            <div>
              <h6 class="text-muted mb-1">Métiers</h6>
              <h4 class="mb-0">{{ stats.metiers }}</h4>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script lang="ts">
  import { defineComponent } from 'vue';
  
  export default defineComponent({
    name: 'GeneralStatsCards',
  
    data() {
      return {
        stats: {
          utilisateurs: 0,
          metiers: 0
        }
      };
    },
  
    methods: {
      async fetchStats() {
        try {
          const response = await this.axios.get('/api/stats/comptes-generaux');
          this.stats = response.data;
        } catch (error) {
          console.error('Erreur lors du chargement des statistiques :', error);
        }
      }
    },
  
    mounted() {
      this.fetchStats();
    }
  });
  </script>
  